<template>
  <div class="pageSections" :class="{ 'pageSections--disableBottomPadding': disableBottomPadding }">
    <template v-if="sections[0].type !== 'ReturnsAndComplaintsSection'">
      <template v-for="(content, contentIndex) in parseContent">
        <div
          :class="[
            'pageSections__group',
            { 'pageSections__group--default': checkDefaultSections(content[0]) },
          ]"
          :key="`content__${contentIndex}`"
        >
          <div v-for="(section, index) in content" class="pageSections__block" :key="index">
            <template v-if="section.type !== 'ReturnsAndComplaintsSection'">
              <component
                :data="section.data"
                :categories="section.categories"
                :brands="section.brands"
                :items="section.items"
                :advices="section.advices"
                :category-object="section.categoryObject"
                :is="`editor-${$helper.kebabCase(section.type)}`"
              />
            </template>
            <template v-else>
              <template v-for="(innerSection, innerIndex) in section.data.sections">
                <component
                  :data="{ ...innerSection }"
                  :is="getSection($helper.kebabCase(innerIndex))"
                  :key="innerIndex"
                />
              </template>
            </template>
          </div>
        </div>
      </template>
    </template>
    <template v-else>
      <div class="pageSections__returns">
        <template v-for="(section, index) in sections[0].data.sections">
          <component
            :data="{ ...section }"
            :is="getSection($helper.kebabCase(index))"
            :key="index"
          />
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import EditorPageContact from '@/components/Editor/Page/EditorPageContact';
import FaqDeliveryTable from '@/components/Editor/Page/FaqDeliveryTable';
import DeliveryTable from '@/components/Editor/Page/DeliveryTable';
import PaymentMethodsTable from '@/components/Editor/Page/PaymentMethodsTable';
import InfoBanner from '@/components/Editor/Page/InfoBanner';
import Wysiwyg from '@/components/Editor/Page/Wysiwyg';
import Points from '@/components/Editor/Page/Points';
import ContractWithdrawalFormPdf from '@/components/Editor/Page/ContractWithdrawalFormPdf';
import EditorPageParagraph from '@/components/Editor/Page/EditorPageParagraph';
import EditorPageEmbed from '@/components/Editor/Page/EditorPageEmbed';
import EditorPageTable from '@/components/Editor/Page/EditorPageTable';
import EditorPageList from '@/components/Editor/Page/EditorPageList';
import LandingHeaderSection from '@/components/Editor/Page/LandingHeaderSection';
import LandingBackgroundHeaderSection from '@/components/Editor/Page/LandingBackgroundHeaderSection.vue';
import LandingBusinessBenefitsTiles from '@/components/Editor/Page/LandingBusinessBenefitsTiles.vue';
import LandingContentBannerSection from '@/components/Editor/Page/LandingContentBannerSection.vue';
import LandingContentIconsBannerSection from '@/components/Editor/Page/LandingContentIconsBannerSection.vue';
import SelectedSubCategories from '@/components/Editor/Page/SelectedSubCategories';
import RecommendedBrandsForCategory from '@/components/Editor/Page/RecommendedBrandsForCategory';
import SelectedArticleCategory from '@/components/Editor/Page/SelectedArticleCategory';
import LogosSliderSection from '@/components/Editor/Page/LogosSliderSection';
import ProductsSection from '@/components/Editor/Page/ProductsSection';
import InfoTilesSection from '@/components/Editor/Page/InfoTilesSection';
import LandingLogosWithDescSection from '@/components/Editor/Page/LandingLogosWithDescSection';
import LandingLeftRightContentSection from '@/components/Editor/Page/LandingLeftRightContentSection';
import EditorPageImage from '@/components/Editor/Page/EditorPageImage';
import EditorHeader from '@/components/Editor/EditorHeader';
import ColumnsTextImage from '@/components/Editor/Page/EditorPageColumnsTextImage.vue';
import EditorCodeTool from '@/components/Editor/EditorCodeTool';
import EditorTrustMateSection from '@/components/Editor/Page/EditorTrustMateSection.vue';

export default {
  name: 'PageSections',
  components: {
    'editor-contact-info-section': EditorPageContact,
    'editor-faq-delivery-table-section': FaqDeliveryTable,
    'editor-delivery-table-section': DeliveryTable,
    'editor-payment-table-section': PaymentMethodsTable,
    'editor-info-banner-section': InfoBanner,
    'editor-wysiwyg-section': Wysiwyg,
    'editor-paragraph': EditorPageParagraph,
    'editor-header': EditorHeader,
    'editor-points-section': Points,
    'editor-table': EditorPageTable,
    'editor-contract-withdrawal-form-pdf-section': ContractWithdrawalFormPdf,
    'editor-embed': EditorPageEmbed,
    'editor-list': EditorPageList,
    'editor-image': EditorPageImage,
    'editor-columns-text-image': ColumnsTextImage,
    'editor-code-tool': EditorCodeTool,
    'editor-landing-header-section': LandingHeaderSection,
    'editor-landing-background-header-section': LandingBackgroundHeaderSection,
    'editor-landing-business-benefits-tiles': LandingBusinessBenefitsTiles,
    'editor-landing-content-banner-section': LandingContentBannerSection,
    'editor-landing-left-right-content-section': LandingLeftRightContentSection,
    'editor-landing-content-icons-banner-section': LandingContentIconsBannerSection,
    'editor-landing-logos-with-desc-section': LandingLogosWithDescSection,
    'editor-info-tiles-section': InfoTilesSection,
    'editor-selected-sub-categories': SelectedSubCategories,
    'editor-recommended-brands-for-category': RecommendedBrandsForCategory,
    'editor-products-section': ProductsSection,
    'editor-selected-article-category': SelectedArticleCategory,
    'editor-logos-slider-section': LogosSliderSection,
    'editor-trust-mate-section': EditorTrustMateSection,
  },
  props: {
    sections: {
      type: Array,
      default: () => [],
    },
    disableBottomPadding: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    parseContent() {
      const newContent = [[]];
      this.sections.forEach(section => {
        if (this.checkDefaultSections(section)) {
          newContent[newContent.length - 1].push(section);
        } else if (newContent.length === 1) {
          newContent[newContent.length - 1].push(section);
        } else {
          newContent.push([]);
          newContent[newContent.length].push(section);
        }
      });

      return newContent;
    },
  },
  methods: {
    checkDefaultSections(section) {
      return (
        section.type === 'header' ||
        section.type === 'list' ||
        section.type === 'paragraph' ||
        section.type === 'image' ||
        section.type === 'embed' ||
        section.type === 'table'
      );
    },
    getSection(type) {
      if (type.includes('wysiwyg')) {
        return 'editor-wysiwyg-section';
      } else if (type.includes('points')) {
        return 'editor-points-section';
      } else if (type.includes('contract-withdrawal-form-pdf')) {
        return 'editor-contract-withdrawal-form-pdf-section';
      } else {
        return type;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.pageSections {
  $root: &;
  &__block {
    padding-bottom: 1.6rem;
  }

  &__returns {
    padding: 1.5rem 3rem;
    background-color: $cWhite;

    @include rwd('small-tablet') {
      padding: 1.5rem;
    }
  }

  &__group {
    &--default {
      background: $cWhite;
      padding: 1.5rem 3rem;
      margin: 0 auto 1.6rem;
      max-width: $gridWidth;

      @include rwd('small-tablet') {
        padding: 1.5rem;
      }
    }
  }

  &--disableBottomPadding {
    #{$root}__block {
      padding-bottom: 0;
    }
  }
}
</style>
